import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=2e974e15&scoped=true"
import script from "./AppList.vue?vue&type=script&lang=js"
export * from "./AppList.vue?vue&type=script&lang=js"
import style0 from "./AppList.vue?vue&type=style&index=0&id=2e974e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e974e15",
  null
  
)

export default component.exports